<template>
    <HomeMap v-if="user.cpf" :user="user"/>
    <InsertCpf v-else :user="user" />

</template>

<script setup>
import HomeMap from './MapsOpenLayers/Home/HomeMap.vue'
import { toRef } from 'vue'
import InsertCpf from "./Configurations/Users/InsertCpf.vue";

const props = defineProps({
    user: { type: Object, required: true }
})

const user = toRef(props, 'user')
</script>
